import { useConfiguration } from '@travel-frontend/core';
import { getCurrentUserId } from '@travel-frontend/user-id';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useWishlistIdentifier } from '../../../../components/Wishlist/hooks/useWishlistIdentifier/useWishlistIdentifier.js';
import { fetchWishlistMetadata, syncSessionWithCustomer } from '../../../../components/Wishlist/redux/wishlist-meta/actions.js';
import { useAuthentication } from '../../../../hooks/useAuthentication/useAuthentication.js';
export const useWishlistMetaSyncEffect = options => {
  const dispatch = useDispatch();
  const url = useConfiguration('wishlistBaseUrl');
  const {
    id,
    type
  } = useWishlistIdentifier();
  const isEnabled = options?.isEnabled ?? true;
  const sessionId = getCurrentUserId();
  const {
    userInfo
  } = useAuthentication();
  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    if (!url) {
      throw new Error('wishlistBaseUrl is not defined in ConfigurationProvider');
    }
    if (id && type) {
      // @ts-expect-error TS(2345) FIXME
      dispatch(fetchWishlistMetadata(url, id, type));
    }
  }, [dispatch, id, type, url, isEnabled]);
  useEffect(() => {
    if (userInfo?.customerID) {
      // @ts-expect-error TS(2345) FIXME
      dispatch(syncSessionWithCustomer(url, userInfo?.customerID, sessionId));
    }
  }, [dispatch, userInfo?.customerID, sessionId, url]);
};